import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { LicenseInfo } from "@mui/x-license-pro";

import { DATE_CONFIG, LuxonAdapter } from "../../utils/date";
import { theme } from "./theme/theme";

if (!LicenseInfo.getLicenseKey()) {
  LicenseInfo.setLicenseKey(
    "c21ec6dd1dd33bf0a6f2fdebc70b5f9cTz0xMTU4NzAsRT0xNzg0ODUxMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
  );
}

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <LocalizationProvider dateAdapter={LuxonAdapter} adapterLocale={DATE_CONFIG.LOCALE}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </LocalizationProvider>
  );
};
